// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bmpui-ui-watermark{display:none}", "",{"version":3,"sources":["webpack://./resources/js/components/Videofile.vue"],"names":[],"mappings":"AACA,oBACI,YAAJ","sourcesContent":["\n.bmpui-ui-watermark {\n    display:none;\n}\n.bmpui-ui-recommendation-overlay {\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
